<label
  [attr.for]="for"
  [ngClass]="
    'mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400 ' + className
  "
>
  <ng-content></ng-content>
</label>